/**
 * LG — Acabados en la tarjeta de producto (snippets/lg-card-swatches.liquid).
 *
 * Al pasar el ratón o enfocar una miniatura, la foto de la tarjeta pasa a la de
 * esa variante; al salir de la fila vuelve la original. En pantallas táctiles el
 * primer toque previsualiza y el segundo (sobre la misma miniatura) abre la ficha
 * en esa variante (?variant=<id>).
 *
 * Todo por delegación en document: sigue funcionando cuando Dawn sustituye la
 * rejilla (filtros/orden AJAX, «cargar más», recomendaciones, quick add).
 */
(function () {
  if (window.__lgCardSwatches) return;
  window.__lgCardSwatches = true;

  let lastPointer = 'mouse';

  function cardOf(el) {
    return el.closest('.card-wrapper') || el.closest('.card');
  }

  function mainImg(card) {
    return card && card.querySelector('.card__media .media img');
  }

  function preview(link) {
    const card = cardOf(link);
    const img = mainImg(card);
    if (!img || !link.dataset.src) return;
    if (!img.dataset.lgOrigSrc) {
      img.dataset.lgOrigSrc = img.getAttribute('src') || '';
      img.dataset.lgOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', link.dataset.srcset || '');
    img.setAttribute('src', link.dataset.src);
    img.loading = 'eager';
    card.classList.add('lg-sw-preview');
    card.querySelectorAll('.lg-card-sw__link.is-active').forEach((a) => a.classList.remove('is-active'));
    link.classList.add('is-active');
  }

  function restore(card) {
    const img = mainImg(card);
    if (img && img.dataset.lgOrigSrc) {
      img.setAttribute('srcset', img.dataset.lgOrigSrcset);
      img.setAttribute('src', img.dataset.lgOrigSrc);
    }
    if (card) {
      card.classList.remove('lg-sw-preview');
      card.querySelectorAll('.lg-card-sw__link.is-active').forEach((a) => a.classList.remove('is-active'));
    }
  }

  document.addEventListener(
    'pointerdown',
    (e) => {
      lastPointer = e.pointerType || 'mouse';
    },
    { passive: true, capture: true }
  );

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType === 'touch') return;
    const link = e.target.closest && e.target.closest('.lg-card-sw__link');
    if (link) preview(link);
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType === 'touch') return;
    const list = e.target.closest && e.target.closest('[data-lg-card-sw]');
    if (!list) return;
    if (e.relatedTarget && list.contains(e.relatedTarget)) return;
    restore(cardOf(list));
  });

  document.addEventListener(
    'keydown',
    () => {
      lastPointer = 'keyboard';
    },
    { passive: true, capture: true }
  );

  document.addEventListener('focusin', (e) => {
    if (lastPointer === 'touch') return; // el toque lo gestiona «click»
    const link = e.target.closest && e.target.closest('.lg-card-sw__link');
    if (link) preview(link);
  });

  document.addEventListener('focusout', (e) => {
    const list = e.target.closest && e.target.closest('[data-lg-card-sw]');
    if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
    if (lastPointer === 'touch') return; // en táctil se mantiene la vista previa
    restore(cardOf(list));
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('.lg-card-sw__link');
    if (!link || lastPointer !== 'touch' || !link.dataset.src) return;
    if (!link.classList.contains('is-active')) {
      e.preventDefault();
      preview(link);
    }
  });
})();
